import { render, staticRenderFns } from "./RegionInfo.vue?vue&type=template&id=a9f1507e&scoped=true&"
import script from "./RegionInfo.vue?vue&type=script&lang=js&"
export * from "./RegionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f1507e",
  null
  
)

export default component.exports